import script from "./ShiftDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftDetail.vue?vue&type=script&setup=true&lang=js"

import "./ShiftDetail.vue?vue&type=style&index=0&id=e59a21ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e59a21ac"]])

export default __exports__